
import { useEffect } from 'react';
import LogRocket from 'logrocket';
import { useAuth } from '@/contexts/AuthContext';

export const useLogRocket = () => {
  const { user, session } = useAuth();

  useEffect(() => {
    // Initialize LogRocket
    LogRocket.init('5vemum/revenue-hub');

    // Identify user once we have their data
    if (user) {
      // Create user properties object with correct typing
      const userProperties = {
        name: `${user.first_name || ''} ${user.last_name || ''}`.trim(),
        email: user.email,
        // LogRocket expects organization to be a primitive value, not an object
        organization: user.organization_name || 'No organization',
        organizationId: user.organization_id || null,
        userType: user.role || 'Unknown',
        hubspotPortalId: user.hubspot_portal_id || null,
        emailDomain: user.email?.split('@')[1] || null,
        accountCreated: session?.user?.created_at || null,
        lastLogin: user.last_login || null,
      };
      
      LogRocket.identify(user.id, userProperties);
      
      console.log('LogRocket: User identified', {
        userId: user.id,
        email: user.email,
        organization: user.organization_name
      });
    }
  }, [user, session]); // Re-run when user or session data changes
};
